// extracted by mini-css-extract-plugin
export default {"itemImage":"loginPage_itemImage__LyO+6","itemImageEnter":"loginPage_itemImageEnter__UD5qP","itemBlock":"loginPage_itemBlock__QArQE","contactButton":"loginPage_contactButton__4UxwX"};